import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import { CaretLeftOutlined, CaretRightOutlined } from '@ant-design/icons';
import './RDTable.scss';

const RDTable = ({
  columns,
  data,
  expandedRowRender,
  pagination,
  scrollWidth,
  onRowClick,
  rowClassName,
  isScrollArrowsVisible,
  tableStyle,
  arrowColor,
  scrollByPX,
  showHeader,
}) => {
  const [disableScrollArrow, setDisableScrollArrow] = useState({
    leftArrow: true,
    rightArrow: false,
  });
  const [rightScrollPos, setRightScrollPos] = useState(0);

  const tableRef = useRef();

  const onScroll = (direction) => {
    if (direction === 'left') {
      tableRef.current.scrollLeft -= scrollByPX;
      setDisableScrollArrow({
        leftArrow: !!(tableRef.current.scrollLeft === 0),
      });
    } else {
      tableRef.current.scrollLeft += scrollByPX;
      setDisableScrollArrow({
        rightArrow: rightScrollPos === tableRef.current.scrollLeft,
        leftArrow: !tableRef.current.scrollLeft > 0,
      });
    }
    setRightScrollPos(tableRef.current.scrollLeft);
  };

  return (
    <div className="rdtable-wrapper">
      {isScrollArrowsVisible && (
        <CaretLeftOutlined
          onClick={() => !disableScrollArrow.leftArrow && onScroll('left')}
          style={
            disableScrollArrow.leftArrow
              ? { cursor: 'not-allowed', color: '#0a7e9212', fontSize: 30, paddingTop: 8 }
              : { color: arrowColor, fontSize: 30, paddingTop: 8 }
          }
        />
      )}
      <div style={tableStyle} ref={isScrollArrowsVisible ? tableRef : null}>
        <Table
          columns={columns}
          expandedRowRender={expandedRowRender}
          dataSource={data}
          pagination={pagination}
          scroll={scrollWidth}
          onRow={onRowClick}
          rowClassName={rowClassName}
          showHeader={showHeader}
        />
      </div>
      {isScrollArrowsVisible && (
        <CaretRightOutlined
          onClick={() => !disableScrollArrow.rightArrow && onScroll('right')}
          style={
            disableScrollArrow.rightArrow
              ? { cursor: 'not-allowed', color: '#0a7e9212', fontSize: 30, paddingTop: 8 }
              : { color: arrowColor, fontSize: 30, paddingTop: 8 }
          }
        />
      )}
    </div>
  );
};

RDTable.defaultProps = {
  columns: [],
  data: [],
  expandedRowRender: null,
  pagination: false,
  scrollWidth: {},
  onRowClick: () => {},
  rowClassName: () => {},
  isScrollArrowsVisible: false,
  tableStyle: {},
  arrowColor: '#83b1b9',
  scrollByPX: 80,
  showHeader: true,
};

RDTable.propTypes = {
  /** Columns of table can be title, dataIndex, key, width,responsive, fixed, ellipsis, colSpan, align,
   *  filterIcon, filters, onFilter, defaultSortOrder, sortOrder, sorter, render
   */
  columns: PropTypes.arrayOf(PropTypes.shape({})),
  /** Data record array to be displayed */
  data: PropTypes.arrayOf(PropTypes.shape({})),
  /** Expanded container render for each row */
  expandedRowRender: PropTypes.func,
  /** Whether pagination is visible */
  pagination: PropTypes.bool,
  /** Whether the table can be scrollable, set horizontal and vertical scrolling as x and y */
  scrollWidth: PropTypes.shape({}),
  /** Set props on per row */
  onRowClick: PropTypes.func,
  /** Row's className */
  rowClassName: PropTypes.func,
  /** Whether the scroll arrows visible */
  isScrollArrowsVisible: PropTypes.bool,
  /** Table's inline styling */
  tableStyle: PropTypes.shape({}),
  /** Color of scroll arrows */
  arrowColor: PropTypes.string,
  /** Scroll to the right in px */
  scrollByPX: PropTypes.number,
  /** Whether to show table header */
  showHeader: PropTypes.bool,
};

export default RDTable;
